// react
import React, { useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

// ant design
import { Modal } from "antd";

// contexts
import ApolloContext from "../../utils/apolloProvider";

// components
import Page from "../../components/Page";

// apollo & operations
import { QUERY_DOCUMENT } from "../../operations/queries/documents";
import { UPDATE_DOCUMENT } from "../../operations/mutations/documents";

// query params
const useQuery = () => new URLSearchParams(useLocation().search);

const DocumentDelete = (props) => {
  const apollo = useContext(ApolloContext);
  const history = useNavigate();
  const { id } = useParams();
  const query = useQuery();
  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "/documents",
      breadcrumbName: "Documents",
    },
    {
      path: "",
      breadcrumbName: "Delete document",
    },
  ];

  const deleteDocument = async () => {
    try {
      const response = await apollo.client.query({
        query: QUERY_DOCUMENT,
        variables: { id },
      });
      const document = { ...response.data.document };
      // @todo should only update hidden
      await apollo.client.mutate({
        mutation: UPDATE_DOCUMENT,
        variables: {
          id: id,
          documentInput: { email: document.email, hidden: true },
        },
      });
      Modal.success({
        title: "Success",
        content: "The document has been hidden.",
        okText: "Return to listing",
        onOk: () => history.replace("/documents"),
      });
    } catch (e) {
      Modal.error({
        title: "An error has occurred",
        content: "The document has not been hidden.",
        okText: "Return to listing",
        onOk: () => history.replace("/documents"),
      });
    }
  };

  useEffect(() => {
    if (query.get("confirm") === "1") {
      deleteDocument();
    }
  }, []);

  return (
    <>
      <Page title="Delete document" breadcrumb={breadcrumb} />
    </>
  );
};

export default DocumentDelete;
